import { render, staticRenderFns } from "./PurchaseNumber.vue?vue&type=template&id=147bf354&"
import script from "./PurchaseNumber.vue?vue&type=script&lang=js&"
export * from "./PurchaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports